export enum DriverCookieName {
  QUICK_SEARCH_MORE_FILTERS = 'driveQuickSearchMoreFilters'
}
